var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAduit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8609 8.23063C14.8922 8.48262 14.9083 8.73931 14.9083 8.99976C14.9083 12.4137 12.1407 15.1812 8.72681 15.1812C5.31289 15.1812 2.54536 12.4137 2.54536 8.99976C2.54536 5.58584 5.31289 2.81831 8.72681 2.81831C9.96883 2.81831 11.1253 3.18461 12.0941 3.81508L13.2061 2.70302C11.9426 1.80258 10.3966 1.27295 8.72681 1.27295C4.45941 1.27295 1 4.73236 1 8.99976C1 13.2672 4.45941 16.7266 8.72681 16.7266C12.9942 16.7266 16.4536 13.2672 16.4536 8.99976C16.4536 8.2795 16.3551 7.58226 16.1707 6.92079L14.8609 8.23063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06151 9.4613L15.5428 2.97997C15.744 2.7788 16.0702 2.7788 16.2713 2.97997L16.6356 3.34421C16.8367 3.54538 16.8367 3.87154 16.6356 4.0727L9.42575 11.2825C9.22459 11.4837 8.89843 11.4837 8.69726 11.2825L5.49462 8.07988C5.29345 7.87872 5.29345 7.55256 5.49462 7.35139L5.85886 6.98715C6.06003 6.78598 6.38619 6.78598 6.58735 6.98715L9.06151 9.4613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAduit);
export default __webpack_public_path__ + "static/media/aduit.18cb947cd0cbbd094762a9c8448497f7.svg";
export { ForwardRef as ReactComponent };